import React from 'react';
import { Image, TouchableOpacity } from 'react-native';
import { Text as TText, useTheme } from '@tamagui/core';
import { YStack, XStack } from '@tamagui/stacks';
import { useTranslation } from 'react-i18next';
import Svg, {
  Defs,
  LinearGradient,
  Stop,
  Text as SvgText,
} from 'react-native-svg';

// Types
import type { RootStackScreenProps } from '@/types/navigation';

// Constants
import { COLORS, COMMON_STYLES } from '@/constants';

// Assets
import { logo } from '@/assets';

type Props = RootStackScreenProps<'Splash'>;

const SplashScreen: React.FC<Props> = ({ navigation }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <YStack
      flex={1}
      backgroundColor="$background"
      justifyContent="space-between"
    >
      <YStack
        flex={1}
        paddingTop="$8"
        alignItems="center"
        justifyContent="center"
        space="$3"
      >
        <Image
          source={logo}
          style={COMMON_STYLES.splashLogo}
        />

        <Svg height={56} width="100%" viewBox="0 0 300 56">
          <Defs>
            <LinearGradient id="tinoGrad" x1="0" y1="0" x2="1" y2="0">
              <Stop offset="0" stopColor="#A77DB1" />
              <Stop offset="1" stopColor="#5E809C" />
            </LinearGradient>
          </Defs>
          <SvgText
            x="150"
            y="42"
            fill="url(#tinoGrad)"
            fontSize="40"
            fontWeight="700"
            fontFamily="Playfair Display"
            textAnchor="middle"
          >
            TINO
          </SvgText>
        </Svg>
      </YStack>

      <YStack paddingHorizontal="$4" paddingBottom="$6" space="$3">
        <XStack justifyContent="space-between" alignItems="center" space="$3">
          <TouchableOpacity
            activeOpacity={0.9}
            onPress={() => navigation.replace('Auth')}
            style={getPrimaryButtonStyle()}
          >
            <TText color="white" fontSize="$4" fontWeight="600">
              {t('screens.auth.loginButton', 'Zaloguj się')}
            </TText>
          </TouchableOpacity>

          <TouchableOpacity
            activeOpacity={0.9}
            onPress={() => navigation.replace('Register')}
            style={getSecondaryButtonStyle(theme)}
          >
            <TText color={COLORS.PRIMARY} fontSize="$4" fontWeight="600">
              {t('screens.splash.createAccount', 'Utwórz konto')}
            </TText>
          </TouchableOpacity>
        </XStack>
      </YStack>
    </YStack>
  );
};

// Styles
function getPrimaryButtonStyle() {
  return {
    ...COMMON_STYLES.splashButton,
    backgroundColor: COLORS.PRIMARY,
  };
}

function getSecondaryButtonStyle(theme: ReturnType<typeof useTheme>) {
  return {
    ...COMMON_STYLES.splashButton,
    backgroundColor: theme.background?.val,
    borderWidth: 2,
    borderColor: theme.borderColor?.val ?? '#e5e7eb',
  };
}

export default SplashScreen;
